'use strict';

/**
 * 从 URL 中解析出 host 和 path 等信息
 * @param {String} url 请求地址
 * @return {{host: String, path: String}}
 */
function parseUrl(theUrl) {
  // 如果不是 http或https或者//或者/开头，则先加上 /
  var url = !theUrl.match(/^[/ | http].*/) ? '/' + theUrl : theUrl;

  // return str.match(/(https?:)?(\/\/)?([^\/]*)\/(.*)/i)
  var matchResult = url.match(/^(https?:)?(\/\/)?([^/]*)\/(.*)/i);
  if (!matchResult) {
    return {
      protocol: '',
      host: '',
      path: url
    };
  }

  return {
    protocol: matchResult[1] || '',
    host: matchResult[3] || '',
    path: '/' + matchResult[4]
  };
}

/**
 * 获得获得传递给 xhr.open 中 url 值
 * @param {String} url 请求地址
 * @param {Object} opts 额外参数
 * @param {String} [opts.host] 地址，例如 now.qq.com
 * @param {String} [opts.protocol] 协议头，例如 http: 或者 https:
 */
function getRequestUrl(url) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var hostAndPath = parseUrl(url);

  var requestHost = hostAndPath.host || opts.host;
  var requestProtocol = hostAndPath.protocol || opts.protocol || '';

  if (!requestHost) {
    // 如果没有 host 信息，则直接返回 path 即可
    return hostAndPath.path;
  }
  // 否则组装完整的请求地址
  return requestProtocol + '//' + requestHost + hostAndPath.path;
}

function isQLiveCgi() {
  var host = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  return host.includes('cgi.qlive.qq.com') || host.includes('tcgi.qlive.qq.com');
}

/**
 * 判断是否 qlive cgi
 * @param host 配置的host
 * @param url 请求地址
 * @return {boolean}
 */
function checkQLiveCgi(host, url) {
  var _parseUrl = parseUrl(url),
      urlHost = _parseUrl.host;

  if (isQLiveCgi(urlHost)) return true;
  return isQLiveCgi(host);
}

/**
 * 添加 query 参数
 * @param url
 * @param paramObj
 * @return {string}
 */
function addQueryParams(url, paramObj) {
  var queryStr = Object.entries(paramObj).map(function (_ref) {
    var name = _ref[0],
        value = _ref[1];
    return name + '=' + value;
  }).join('&');
  return '' + url + (url.includes('?') ? '&' : '?') + queryStr;
}

module.exports = {
  parseUrl: parseUrl,
  getRequestUrl: getRequestUrl,
  checkQLiveCgi: checkQLiveCgi,
  addQueryParams: addQueryParams
};